import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudePageLocation} from "../../promotion/tracking/OfferPageAmplitudeItemListTrackingContext";

interface ITrackAmplitudeEnablePriceAlertParams {
    itemId: number;
    propertyId: number;
    location: AmplitudePageLocation;
}

export const trackAmplitudeEnablePriceAlert = ({itemId, propertyId, location}: ITrackAmplitudeEnablePriceAlertParams): void => {
    trackAmplitudeEvent("enable_price_alert", {
        item_id: itemId,
        property_id: propertyId,
        location
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudePageLocation} from "../../promotion/tracking/OfferPageAmplitudeItemListTrackingContext";

interface ITrackAmplitudeEnablePriceAlertParams {
    itemId: number;
    propertyId: number;
    location: AmplitudePageLocation;
}

export const trackAmplitudeEnablePriceAlert = ({itemId, propertyId, location}: ITrackAmplitudeEnablePriceAlertParams): void => {
    trackAmplitudeEvent("enable_price_alert", {
        item_id: itemId,
        property_id: propertyId,
        location
    });
};
